import { Avatar, Box, Button, Grid, Menu, MenuItem, Paper, Select, Stack, Tooltip, Typography } from "@mui/material";
import { CustomSearchInput, FORM_SELECTFIELD_STYLES, PLATFORMS_IMGS_LIST, START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT, TOOLTIP_STYLES, trunCateString } from "../../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import CreateWishlistModal from "../../components/dialog/CreateWishlistModal";
import editIcon from '../../assets/images/icons/edit2.svg'
import { addEditWishlistReducer } from "./addEditWishlistSlice";
import deleteIcon from '../../assets/images/icons/deleteIconRed.svg'
import DeleteModal from "../../components/dialog/DeleteModal";
import { useDeleteWishlistMutation, useGetUserWishlistQuery, useGetWishlistInfluncersQuery } from "../../redux/api";
import { updateWishlist } from "./wishlistSlice";
import CustomizedSnackbars from "../../components/snackbar";
import WishlistInfluncersListing from "./WishlistInfluncersListing";
import stars from '../../assets/images/icons/stars.png'
import { CustomSelectIcon, isLessThanTwoDaysAgo } from "../../utils/common";
import rightCaret from '../../assets/images/icons/rightCaret.svg'
import { useLocation, useNavigate } from "react-router-dom";
import { updateGlobalLoader } from "../../components/backdrop/backdropSlice";
import actionIcon from '../../assets/images/icons/actionIcon.svg'
const Wishlist = () => {
   const dispatch = useDispatch();
   const location = useLocation();
   const navigate = useNavigate();
   const {isScreenZoomed} = useSelector(state=>state.commonSlice);
   const wishlistShareId = location?.state?.wishlistId || null;
  const [selectedWishlistId, setSelectedWishlistId] = useState(null);
  const [wishlistSortValue, setWishlistSortValue] = useState("All");
  const [searchWishlistValue, setSearchWishlistValue] = useState("");
  const [pageForInfluencerList, setPageForInfluencerList] = useState(0);
  const [limitForInfluencerList] = useState(20);
  const [hasMoreForInfluencerList, setHasMoreForInfluencerList] = useState(true);
  const [influencerSearch, setInfluencerSearch] = useState("");
  const currentPageForInfluencerList = useRef(parseInt(pageForInfluencerList || '0'));
  const [dummyNumberForFetchInfluencerList,setDummyNumberForFetchInfluencerList] = useState(null);
  const [checkIfNoListIsAvailabel,setCheckIfNoListIsAvailabel] = useState(true);
  const [actionDropdownState,setActionDropdownState] = useState(null);
  const [selectedWishlistForAction,setSelectedWishlistForAction] = useState(null);
  const { data: influencerList, isLoading: isInfluencerListApiCalling, isFetching } = useGetWishlistInfluncersQuery({
    wishlistId: selectedWishlistId,
    page: pageForInfluencerList,
    limit: limitForInfluencerList,
    sideBar: false, search: influencerSearch,dummyNumberForFetchInfluencerList:dummyNumberForFetchInfluencerList
  }, { skip: !selectedWishlistId,  })
  const { data, isSuccess } = useGetUserWishlistQuery({
    sortBy: wishlistSortValue, search: searchWishlistValue
  });
  const [deleteWishlist] = useDeleteWishlistMutation();
  const [snackbar, setSnackbar] = useState({
    message: "",
    severity: "success",
    open: false,
  });
  useEffect(() => {
    dispatch(updateWishlist({
      wishlistInfluncers: []
    }));
  }, [])
  const handleClickOnWishlist = (id)=>{
    setSelectedWishlistId(id);
    setPageForInfluencerList(0);
    setDummyNumberForFetchInfluencerList(Math.random()*99999);
      dispatch(updateWishlist({
      wishlistInfluncers: []
    }));
  }

  useEffect(() => {
    const shouldShowLoader = isInfluencerListApiCalling || isFetching;
    dispatch(updateGlobalLoader(shouldShowLoader));
    dispatch(updateGlobalLoader(shouldShowLoader ? true : false));
  }, [dispatch, isInfluencerListApiCalling, isFetching])

  const loadMoreInfluencerList = useCallback(() => {
    if (isInfluencerListApiCalling || !hasMoreForInfluencerList) return;
    const nextPage = currentPageForInfluencerList.current + 1;
    currentPageForInfluencerList.current = nextPage;
    setPageForInfluencerList(nextPage)
  }, [isInfluencerListApiCalling, hasMoreForInfluencerList]);
  useEffect(() => {
    if (data?.status === "SUCCESS") {
      const response = data?.result?.data || [];
         const firstId = response?.[0]?.id;
         setSelectedWishlistId(wishlistShareId || firstId || null);
         setPageForInfluencerList(0);
        //  did this random thing to call api on every change of search wishlist 
         setDummyNumberForFetchInfluencerList(Math.random()*99999);
         const finalData = [...response];
         if(wishlistShareId){
           const index = finalData?.findIndex((item) => item?.id === wishlistShareId);
           if (index !== -1 && index !== 0) {
             [finalData[0], finalData[index]] = [finalData[index], finalData[0]]
           }

         }
      const shouldShowEmptyStateForWishlist = finalData.length <= 0 && !searchWishlistValue && wishlistSortValue === 'All';
      setCheckIfNoListIsAvailabel(shouldShowEmptyStateForWishlist);
         dispatch(updateWishlist({ wishlistList:finalData, totalCount: data?.result.count }))
         navigate(location.pathname, { replace: true });
    }
  }, [isSuccess, data, dispatch]);
  const [createWishlistModalOpen, setCreateWishlistModalOpen] = useState(false);
  const [deleteWishlistModalOpen, setDeleteWishlistModalOpen] = useState(false);
  const [selectedListItems, setSelectedListItems] = useState([]);
 
  const { wishlistList, wishlistInfluncers } = useSelector((state) => state.wishlistSlice);
  useEffect(() => {
    if (influencerList?.result?.data?.length > 0) {
      const newData = influencerList.result.data;
      const combinedList = [...wishlistInfluncers, ...newData];
      dispatch(updateWishlist({
        wishlistInfluncers: combinedList
      }));
    }
  }, [influencerList?.result?.data]);
  const handleDeleteList = async () => {
    try {
      const res = await deleteWishlist({ ids: selectedListItems }).unwrap();
      if (res.status === "SUCCESS") {
        setSnackbar({
          message: res.message,
          severity: "success",
          open: true,
        });
        setDeleteWishlistModalOpen(false);
        setSelectedListItems([]);
        setActionDropdownState(null);
        setSelectedWishlistForAction(null);
        setPageForInfluencerList(0);
        dispatch(updateWishlist({
          wishlistInfluncers: []
        }));
      } else {
        setSnackbar({
          message: res.message,
          severity: "error",
          open: true,
        });
      }
    } catch (error) {
      setSnackbar({
        message: "Something went wrong",
        severity: "error",
        open: true,
      });
    }
  }
  const handleSearchWishlist = (e)=>{
    setSearchWishlistValue(e.target.value) ;
    setPageForInfluencerList(0)
    dispatch(updateWishlist({
        wishlistInfluncers: []
      }));
  }

  const handleWishlistFilter = (e)=>{
    setWishlistSortValue(e.target.value);
    setPageForInfluencerList(0)
        dispatch(updateWishlist({
        wishlistInfluncers: []
      }));
  }
const handleChangeActionMenu = (e,item)=>{
  e.preventDefault();
  e.stopPropagation();
  setActionDropdownState(prev => (prev ? null : e.currentTarget));
  if(item) {setSelectedWishlistForAction(item)}
  else{setSelectedWishlistForAction(null)};
}
  return (
    <>
      <CustomizedSnackbars msgData={snackbar} setMsgData={setSnackbar} />
      <CreateWishlistModal open={createWishlistModalOpen} setOpen={setCreateWishlistModalOpen} shouldNavigate={true} setSelectedWishlistForAction={setSelectedWishlistForAction} setActionDropdownState={setActionDropdownState}/>
      <DeleteModal handleDelete={handleDeleteList} open={deleteWishlistModalOpen} setOpen={setDeleteWishlistModalOpen} title={`Delete ${selectedListItems.length === 1 ? trunCateString(wishlistList?.find((i) => i.id === selectedListItems[0])?.name,10) : 'Selected'} list from the Lists`} subHeading={`Are you sure you want to delete ${selectedListItems.length === 1 ? trunCateString(wishlistList?.find((i) => i.id === selectedListItems[0])?.name,10) : 'Selected'} from your Lists?`} />
      <Grid container sx={{  height: isScreenZoomed ? '91vh' : '93vh', overflow: 'hidden', paddingTop: '20px',border:'0px solid red' }}>
        <Grid item sx={{display:checkIfNoListIsAvailabel && 'none'}} xs={checkIfNoListIsAvailabel ? 0 : 2.5} borderRight={"1px solid #F0F0F0"}>
          <Stack direction="row" justifyContent={"space-between"} alignItems={"center"} padding={"0 16px"} >
            <Typography sx={{fontSize:isScreenZoomed ? "20px" : '24px', fontWeight:600,color:'black'}}>My Lists</Typography>
            <Button
              sx={{
                borderRadius: '10px', position: 'relative', background: 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '2px', overflow: 'hidden',
              }}
              onClick={() => {
                setCreateWishlistModalOpen(true)
              }}>
              <Typography sx={{
                padding: isScreenZoomed ? "10px 15px" : '10px 20px', background: 'white', borderRadius: '8px', color: '#000000', fontWeight: '600', fontSize: '16px', height: '100%', "&:hover": { background: 'transparent', color: 'white' }
              }}>
                {isScreenZoomed ? "Create List" : "Create New List"}
              </Typography>
            </Button>
          </Stack>

          <Stack direction="row" justifyContent={"flex-start"} alignItems={"center"} >
          <CustomSearchInput
            className="inputSearch sContrl p-0 "
            value={searchWishlistValue}
            sx={{
              width: '100%', margin: '16px', marginBottom: '0',
            }}
            placeholder={"Search List..."}
            handleSearch={(e) => { handleSearchWishlist(e)}}
            clearSearch={() => { setSearchWishlistValue("") }}
            startAdornment={START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT
            }
          />
          </Stack>
          <Stack direction="row" justifyContent={"space-between"} alignItems={"center"} padding={"10px 16px 0 16px"}>
            <Typography fontSize={14} fontWeight={400} color={"#726C6C"} border={0}>{wishlistList?.length || 0} Lists</Typography>
            <Select
              IconComponent={(props) => (
                <CustomSelectIcon image={rightCaret} style={{ height: '18px', width: '18px', rotate: '90deg' }} {...props} />)}
              sx={{ ...FORM_SELECTFIELD_STYLES, width: '110px', height: '36px', fontSize: '14px', }} MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: "8px",
                    mt: 1,
                  },
                },
              }}
              required={false}
              name={``}
              label={("")}
              value={wishlistSortValue}
              onChange={(e) => { handleWishlistFilter(e) }}>
              {["All", "Instagram", "Youtube", "Latest", "Oldest"]?.map(
                (v) => {
                  return (
                    <MenuItem value={v} key={v}>
                      {v}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </Stack>
          <Paper sx={{
            height: isScreenZoomed ? '68vh' : '75vh',
            overflow: 'hidden', padding: '20px 16px',border:'0',boxShadow:0,
          }}>
           {wishlistList?.length>0 ?  <Stack direction="column" gap={0} sx={{
              padding: 0, height: '100%', border: 0, overflowY: 'scroll', overflowX: 'hidden', scrollbarWidth: 0, '&::-webkit-scrollbar': {
                display: 'none',
              },
            }}>
              {
                wishlistList?.map((ele, i) => {
                  const isSelected = ele?.id === selectedWishlistId;
                 const isNew =  isLessThanTwoDaysAgo(ele?.created_at)
                  return (
                    <Stack key={ele.id} onClick={() => handleClickOnWishlist(ele?.id)} direction="row" justifyContent="space-between" alignItems="center" sx={{ position:'relative',cursor: 'pointer', marginBottom: wishlistList?.result?.length === i + 1 ? '20px' : 0, borderBottom: '1px solid #F0F0F0',borderTop:0, borderRadius: isSelected ? '6px' : '0px', height: isScreenZoomed ? '80px' : '100px', padding: isScreenZoomed ? '10px' : '20px 16px', background: isSelected ? '#DBECFF' : 'white', }}>
                      <Stack direction="row" justifyContent="flex-start" gap={1} alignItems="center" sx={{ width: '100%' }}>
                        <Avatar src={ele?.brandImage} sx={{ height: '40px', width: '40px' }} />
                        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={isScreenZoomed ? 1 : 2} sx={{ width: isScreenZoomed ? '70%' : '60%', }}>
                          <Box>
                            <Tooltip arrow componentsProps={TOOLTIP_STYLES} placement="top" title={ele?.name} >
                            <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#000000', textTransform: 'capitalize' }}>{trunCateString((ele?.name || 'Unknown'), isScreenZoomed ? 7 : 12)}</Typography>
                            </Tooltip>
                            <Typography sx={{ fontWeight: 400, fontSize: '12px', color: '#726C6C', textTransform: 'capitalize' }}>{trunCateString(ele.brandName, isScreenZoomed ? 7 : 12)}</Typography>
                          </Box>
                        </Stack>
                      </Stack>
                      <Stack direction="row" justifyContent="flex-end" alignContent="center" gap={2} sx={{ border: '0px solid red' }}>
                        <img src={PLATFORMS_IMGS_LIST[ele?.platform]} alt={ele?.platform} style={{ height: '24px', width: '24px' }} />
                        <Button aria-controls={actionDropdownState ? 'action-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={Boolean(actionDropdownState)} onClick={(e)=>handleChangeActionMenu(e,ele)} sx={{ "&:hover": { background: 'none', }, textAlign: 'right', padding: 0, minWidth: 'fit-content' }} disableRipple><img src={actionIcon} alt="actionIcon" /></Button>
                      </Stack>
                      {isNew && <Typography sx={{position:'absolute',top:'5px',right:'10px',fontSize:'12px',fontWeight:'700',background:'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)',color:'transparent', backgroundClip: 'text',}}>New</Typography>}
                    </Stack>
                  )
                })
              }</Stack> : <Stack height={"100%"} direction={"column"} justifyContent="center" alignItems={"center"} gap={4}>
                <img src={stars} alt="stars" style={{height:'48px',width:'48px'}} />
                <Box>
                  <Typography fontSize={24} fontWeight={700} color={"black"} textAlign={"center"}>Let’s Get You Started!</Typography>
                  <Typography fontSize={14} fontWeight={400} color={"#726C6C"} textAlign={"center"}>You haven’t created any lists yet—click below to make your first one.</Typography>
                </Box>
                     <Button
              sx={{
                borderRadius: '10px', position: 'relative', background: 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '2px', overflow: 'hidden',
              }}
              onClick={() => {
                setCreateWishlistModalOpen(true)
              }}>
              <Typography sx={{
                padding: '10px 20px', background: 'white', borderRadius: '8px', color: '#000000', fontWeight: '600', fontSize: '16px', height: '100%', "&:hover": { background: 'transparent', color: 'white' }
              }}>
                Create New List
              </Typography>
            </Button>
                </Stack>}
          </Paper>
        </Grid>
        <Grid item xs={checkIfNoListIsAvailabel ? 12 : 9.5}>
          <WishlistInfluncersListing checkIfNoListIsAvailabel={checkIfNoListIsAvailabel} isFetching={isFetching} isInfluencerListApiCalling={isInfluencerListApiCalling} loadMore={loadMoreInfluencerList} currentPage={currentPageForInfluencerList} isLoading={isInfluencerListApiCalling} page={pageForInfluencerList} limit={limitForInfluencerList} setInfluencerSearch={setInfluencerSearch} influencerSearch={influencerSearch} hasMore={hasMoreForInfluencerList} setHasMore={setHasMoreForInfluencerList} wishlistId={selectedWishlistId} influencerList={influencerList?.result?.data} totalCount={influencerList?.result?.totalCount} setPage={setPageForInfluencerList} />
        </Grid>
      </Grid>
       <Menu
                        anchorEl={actionDropdownState}
                        open={Boolean(actionDropdownState)}
                        onClose={handleChangeActionMenu}
                        sx={{
                          '& .MuiMenu-list': {
                            paddingTop: 0, paddingBottom: 0,
                          }
                        }}
                        PaperProps={{
                          sx: {
                            mt: -0.7,
                            borderRadius: '12px',
                            backgroundColor: '#fff',
                            width: '120px',
                            marginTop: '5px', padding: '0px', boxShadow: '0 0 24px 0 rgba(0, 0, 0, 0.10)',
                          }
                        }}
                      >
                        <MenuItem
                          disableRipple
                          sx={{
                            borderBottom: '1px solid #EEE', display: 'flex', justifyContent: 'space-between',
                            alignItems: 'center !important', padding: '10px !important', "&:hover": { background: '#0077FF1A', "& #mainDropdownWishlist": { background: 'transparent', } }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                          }}
                          onClick={(v) => {
                            v.preventDefault();
                            v.stopPropagation();
                            setCreateWishlistModalOpen(true);
                            dispatch(addEditWishlistReducer(selectedWishlistForAction));
                            handleChangeActionMenu(v);
                          }}
                          defaultValue=""
                        >
                          <Stack direction={"row"} justifyContent="flex-start" gap={1} alignItems="center">
                            <img src={editIcon} alt="edit" style={{ height: '20px', width: '20px' }} />
                            <Typography fontSize={14} fontWeight={400} color={"#565656"}>Edit</Typography>
                          </Stack>
                        </MenuItem>
                        <MenuItem
                          disableRipple
                          sx={{
                            display: 'flex', justifyContent: 'space-between',
                            alignItems: 'center !important', padding: '10px !important', "&:hover": { background: '#0077FF1A', "& #mainDropdownWishlist": { background: 'transparent', } }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                          }}
                          onClick={(v) => {
                            v.preventDefault();
                            v.stopPropagation();
                            setSelectedListItems([selectedWishlistForAction?.id])
                            setDeleteWishlistModalOpen(true);
                          }}
                          defaultValue=""
                        >
                          <Stack direction={"row"} justifyContent="flex-start" gap={1} alignItems="center">
                            <img src={deleteIcon} alt="deleteIcon" style={{ height: '18px', width: '18px' }} />
                            <Typography fontSize={14} fontWeight={400} color={"#565656"}>Delete</Typography>
                          </Stack>
                        </MenuItem>
                      </Menu>
    </>
  )
}
export default Wishlist
